import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { CustomChip } from '../CustomChip';
import { useEffect, useState } from 'react';

export const CompanyBadge = (props) => {
    const navigate = useNavigate();
    const { getUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();

    const [companyId, setCompanyId] = useState('')

    const getName = () => {
        return props.accountId !== userDetails?.contact.accountId ? props.accountName : userDetails?.contact.firstName + ' ' + userDetails?.contact.lastName;
    };

    const getCompanyId = () => {
        const item = userDetails?.businessList?.find(item=> item.accountId === props.accountId);
        return item ? item?.id : ''
    };

    const isLink = Boolean(props.isLink && !!companyId);

    const handleClick = (event) => {
        if (!isLink) return;
        event.preventDefault();
        event.stopPropagation();
        const url = `/my-companies/${companyId}`;
        // if (props.openInNewTab) {
        //     window.open(url, '_blank', 'noopener,noreferrer');
        //     return;
        // }
        navigate(url);
    };

    useEffect(()=>{
        props.isLink && setCompanyId(getCompanyId())
    },[props.accountId])

    return (
        <CustomChip
            label={getName()}
            color="default"
            variant="outlined"
            {...(isLink && {
                clickable: true,
                onClick: handleClick,
                onMouseDown: (event) => event.stopPropagation(),
                sx: { textDecoration: 'none', cursor: 'pointer' },
            })}
        />
    );
};
